<template>
  <div class="configuration-layout">
    <SuiMenu
      class="configuration-menu"
      vertical
    >
      <SuiMenuItem
        class="item"
        :class="{ active: component === 1 }"
        @click="selection(1)"
      >
        Generales
      </SuiMenuItem>
      <SuiMenuItem
        class="item"
        :class="{ active: component === 5 }"
        @click="selection(5)"
      >
        Facturacion automatica
      </SuiMenuItem>
      <SuiMenuItem
        class="item"
        :class="{ active: component === 7 }"
        @click="selection(7)"
      >
        Pagos con tarjeta
      </SuiMenuItem>
      <SuiMenuItem
        class="item"
        :class="{ active: component === 8 }"
        @click="selection(8)"
      >
        Timbrado (CSD)
      </SuiMenuItem>
      <SuiMenuItem
        class="item"
        :class="{ active: component === 9 }"
        @click="selection(9)"
      >
        Correo remitente
      </SuiMenuItem>
      <SuiMenuItem
        class="item"
        :class="{ active: component === 10 }"
        @click="selection(10)"
      >
        Importación inicial
      </SuiMenuItem>
      <SuiMenuItem>
        <sui-icon name="whatsapp" /> WhatsApp
        <SuiMenu vertical>
          <SuiMenuItem
            :class="{ active: component === 2 }"
            @click="selection(2)"
          >
            Configuracion
          </SuiMenuItem>
          <SuiMenuItem
            :class="{ active: component === 3 }"
            @click="selection(3)"
          >
            Plantillas de mensajes
          </SuiMenuItem>
          <SuiMenuItem
            :class="{ active: component === 6 }"
            @click="selection(6)"
          >
            Reglas de pago
          </SuiMenuItem>
          <SuiMenuItem
            :class="{ active: component === 4 }"
            @click="selection(4)"
          >
            Enviar mensaje manual
          </SuiMenuItem>
        </SuiMenu>
      </SuiMenuItem>
    </SuiMenu>
    <div class="contents">
      <GeneralSettings v-if="component == 1" />
      <AutoInvoiceConfig v-if="component == 5" />
      <CardPaymentSettings v-if="component == 7" />
      <SatCertificate v-if="component == 8" />
      <SenderEmail v-if="component == 9" />
      <OnboardingImport v-if="component == 10" />
      <WhatsAppConfig v-if="component == 2" />
      <WhatsAppTemplates v-if="component == 3" />
      <WhatsAppReminderRules v-if="component == 6" />
      <SendWhatsapp v-if="component == 4" />
    </div>
  </div>
</template>

<script setup>
    import GeneralSettings from "./components/GeneralSettings.vue";
    import AutoInvoiceConfig from "./components/AutoInvoiceConfig.vue";
    import CardPaymentSettings from "./components/CardPaymentSettings.vue";
    import SatCertificate from "./components/SatCertificate.vue";
    import SenderEmail from "./components/SenderEmail.vue";
    import OnboardingImport from "../products/views/OnboardingImport.vue";
    import WhatsAppConfig from "./components/WhatsAppConfig.vue";
    import WhatsAppTemplates from "./components/WhatsAppTemplates.vue";
    import WhatsAppReminderRules from "./components/WhatsAppReminderRules.vue";
    import SendWhatsapp from "./components/SendWhatsapp.vue";
    import { ref } from "vue";

    const component = ref(1);

    const selection = (section) => {
        return (component.value = section);
    };
</script>

<style scoped>
.configuration-layout {
    display: grid;
    grid-template-columns: 210px minmax(0, 1fr);
    gap: 24px;
    align-items: start;
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
}

.configuration-menu {
    width: 100% !important;
    margin: 0 !important;
}

.contents {
    min-width: 0;
    padding: 0 24px;
}

@media (max-width: 767px) {
    .configuration-layout {
        grid-template-columns: 1fr;
    }

    .contents {
        padding: 0;
    }
}
</style>
